module.exports = __webpack_public_path__ + "01_glasses_blue.351e3c89.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer4/01_glasses_blue.png
// module id = 2g07
// module chunks = 0